import delivered from "../assets/orderStatusIcons/delivered.svg";
import dispatched from "../assets/orderStatusIcons/dispatched.svg";
import processing from "../assets/orderStatusIcons/processingIcon.svg";
import readyToDispatch from "../assets/orderStatusIcons/readyToDispatch.svg";

export const orderSummaryStages = [
  { title: "New" },
  { icon: processing, title: "Order Approved" },
  { icon: processing, title: "Processing" },
  { icon: readyToDispatch, title: "Ready for dispatch" },
  { icon: dispatched, title: "Dispatched" },
  { icon: delivered, title: "Delivered" },
];
